import { lazy } from 'react';
const FgAgeAnalysis = lazy(() => import('./FgAgeAnalysis'));

const FgAgeAnalysisRoutes = [
  {
    path: '/fg-age-analysis',
    component: FgAgeAnalysis
  }
];

export default FgAgeAnalysisRoutes;
